/** Normalizes administration route from form/API (string or joined lookup object) for storage and display. */
export function normalizeAdministrationRouteValue(value: unknown): string | null {
  if (value == null || value === "") return null;
  if (typeof value === "object" && value !== null && "name" in value) {
    const name = (value as { name?: unknown }).name;
    return typeof name === "string" && name.trim() ? name.trim() : null;
  }
  if (typeof value === "string") return value.trim() || null;
  return null;
}
